import isArray from 'lodash/isArray'

/**
 * Returns the pretty role name form a role.
 * @param {string} role
 * @returns {string} Pretty Role
 */
export const getRoleName = role => {
  switch (role) {
    case 'admin':
      return 'Administrator'

    case 'advisor':
      return 'Advisor'

    case 'designer':
      return 'Designer'

    case 'reseller':
      return 'Reseller'

    case 'external':
      return 'External'

    default:
      return 'User'
  }
}

/**
 * Checks whether object is empty.
 * @param {object} user
 * @returns {string} user name string
 */
export const getUserName = user => {
  if (user && typeof user === 'object') {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`
    }
  }

  return ''
}

/**
 * Gets the user setting
 * @param {Object} user
 * @param {string} setting
 * @returns {string|bool}
 */
export const getUserSetting = (user, setting) => {
  if (user && typeof user === 'object') {
    if (user.settings) {
      const userSetting = user.settings.find(userSetting => userSetting.setting === setting)

      if (userSetting) {
        return userSetting.value
      }
    }
  }

  return
}

/**
 * Checks whether the user is a role.
 * @param {object} user
 * @param {string|string[]} roles
 * @returns {boolean}
 */
export const isRole = (user, roles) => {
  if (user) {
    if (user.roles) {
      if (isArray(roles)) {
        for (const r of roles) {
          if (user.roles.includes(r)) {
            return true
          }
        }
      } else {
        return user.roles.includes(roles)
      }
    }
  }

  return false
}
